import settings from '../../utils/settings';
import alterDate from '../../utils/dates/alterDate';

/**
 * Default structure for the `hc` object
 */
const defaultStorage = {
  location: {
    zip_code: '',
    state_acronym: '',
    state: '',
    county: '',
    city: '',
  },
  cache: {
    locationByZip: {},
  },
  household: {
    size: 1,
    income: '',
    fpl: '',
  },
  contact: {
    first_name: '',
    last_name: '',
    email_address: '',
    address: '',
    phone_home: '',
    is_mobile: '',
  },
  members: [],
  life_event: 0,
  leadid: {
    universal_leadid: '',
    sended: false,
  },
  invoca_phone: {
    promo_number: '',
    promo_number_formatted: '',
  },
  utm: {
    utm_source: '',
    utm_campaign: '',
    utm_medium: '',
    utm_content: '',
    utm_term: '',
  },
  aid: '',
  pubid: 0,
  subid: 0,
  gclid: '',
  msclkid: '',
  irpid: '',
  ircid: '',
  bt_sid: '',
  source: '',
  pixel: '',
  url_version: '',
  landing_url: '',
  picreel_time: 0,
  healthcareSession: '',
  healthcareUserId: '',
  flowCatch: { show: false },
  agent_id: '',
  version: settings.version,
  period: 364,
  sdate: (function startDate() {
    const tomorrow = alterDate({ days: 1 });
    const monthString = `${tomorrow.getMonth() + 1}`;
    const month = `0${monthString}`.substring(monthString.length - 1);
    return `${month}/${tomorrow.getDate()}/${tomorrow.getFullYear()}`;
  }()),
};

export default defaultStorage;
